import ApiService from '@/services/api'
import { defineStore } from 'pinia'
//import { taskUpdateService } from '@/rxjsServices';

const ENDPOINT = '/tasktypeprices/'
const ITEM_ID  = 'tpr_id'

export const useTasktypepriceStore = defineStore('tasktypeprices', {
  // convert to a function
  state: () => ({
    item: { tpr_typ_id: 'ZON01', tpr_amount_ht: 0 },
    itemList: [],
    meta: {}
  }),
  getters: {

  },
  actions: {
    fetchItem (id, options) {
        return new Promise( (resolve, reject) => {
            options = (options) ? '/' + options : ''
            if( id && id > 0 ){
                ApiService.get(ENDPOINT + id + options).then( (response) => {
                    if( !response.data.data.pro_customfields || Object.prototype.toString.call( response.data.data.pro_customfields ) === '[object Array]' ) {
                        response.data.data.pro_customfields = {}
                    }
                    this.SET_ITEM(response.data.data)
                    resolve(this.item)
                }).catch( (error) => { 
                    reject(error)
                })
            } else {
                this.RESET_ITEM()
                resolve(this.item)
            }
        })
    },
    fetchItems (options) {
        return new Promise( (resolve, reject) => {
            options = (options) ? options : ''
            ApiService.get( ENDPOINT + options ).then( (response) => {
                this.meta = response.data.meta
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    //this.SET_ITEMS(response.data.data)
                    this.itemList = response.data.data
                }
                resolve('resolved')
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    storeItem (item) {
        return new Promise( (resolve, reject) => {
            if(item){
                this.SET_ITEM(item)
            }
            ApiService.post( ENDPOINT, this.item ).then( (response) => {
                this.SET_ITEM(response.data.data)
                resolve(this.item)
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    updateItem (item) {
        return new Promise( (resolve, reject) => {
            if(item){
                this.SET_ITEM(item)
            }
            ApiService.put( ENDPOINT + this.item[ITEM_ID], this.item ).then( (response) => {
                this.SET_ITEM(response.data)
                resolve(this.item)
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    destroyItem (id) {
        return new Promise( (resolve, reject) => {
            this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
            ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then( () => {
                this.RESET_ITEM()
            resolve('resolved')
            }).catch( (error) => { 
            reject(error)
            })
        })
    },
    //***************************MUTATIONS ***************************************/
    SET_ITEM (item) {
      this.item = item
    },
    SET_ITEMS (itemList) {
      this.itemList = itemList
    },
    RESET_ITEM () {
      this.item = { tpr_typ_id: 'ZON01', tpr_amount_ht: 0 }
    }
  }
})
